import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { eur0, num } from "../lib/fmt";
import { Spinner } from "../components/common";

const MEDAL = ["🥇", "🥈", "🥉"];

export default function Ranking() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/ranking").then(({ data }) => setR(data)).catch(() => setR({ items: [], prizes: [], closures: [] })); }, []);
  if (!r) return <Spinner />;
  if (r.locked) return (
    <>
      <div className="page-intro"><div className="eyebrow">MUY PRONTO</div><h1>🏆 Ranking semanal</h1></div>
      <div className="card highlight-card" style={{ textAlign: "center" }} data-testid="ranking-maintenance">
        <div style={{ fontSize: 48 }}>🛠️</div>
        <h2>Ranking en mantenimiento</h2>
        <p className="muted">Estamos preparando la competición semanal. Se activará muy pronto. Mientras tanto, sigue sumando XP con tus misiones y actividades.</p>
        <span className="badge gold">Próximamente</span>
      </div>
    </>
  );
  return (
    <>
      <div className="page-intro"><div className="eyebrow">UN POCO DE COMPETICIÓN SANA</div><h1>🏆 Ranking semanal</h1><p className="lead">Clasificación generada solo con usuarios reales verificados y actividades verificadas de esta semana (desde el lunes {r.week}). Mostramos únicamente un alias.</p></div>
      <div className="card"><span className="badge gold">👁️ Datos reales de la plataforma · sin perfiles inventados</span>
        <div style={{ overflowX: "auto" }}>
          {r.items.length === 0 ? null : (
            <table className="leaderboard" data-testid="ranking-table"><thead><tr><th>Posición</th><th>Perfil</th><th>Acciones</th><th>XP semanal</th></tr></thead>
              <tbody>{r.items.map((i) => <tr key={i.position} className={i.me ? "me" : ""} data-testid={`ranking-row-${i.position}`}><td>{MEDAL[i.position - 1] || "⭐"} {i.position}</td><td>{i.alias}{i.me ? " (tú)" : ""}</td><td>{i.actions}</td><td>{num(i.xp)} XP</td></tr>)}</tbody></table>
          )}
        </div>
        {r.items.length < r.prizes.length && (
          <div className="kpi-strip" style={{ marginTop: 14 }} data-testid="ranking-free-slots">
            {r.prizes.slice(r.items.length).map((p, k) => { const pos = r.items.length + k + 1; return (
              <div className="kpi-tile highlight-card" key={pos} data-testid={`ranking-free-${pos}`}><span>{MEDAL[pos - 1] || "⭐"} {pos}.º puesto · libre</span><b className="lime">+{eur0(p)}</b><span className="tiny muted">¡Este puesto puede ser tuyo esta semana!</span></div>
            ); })}
          </div>
        )}
        {r.me && r.me.position > 20 && <p className="tiny muted">Tu posición: {r.me.position} · {num(r.me.xp)} XP</p>}
      </div>
      <div className="card" style={{ marginTop: 18 }}><h2>🥇 Premios de la competición</h2><p className="muted">{r.criteria}</p>
        <div className="kpi-strip">{r.prizes.map((p, i) => <div className="kpi-tile" key={i}><span>{MEDAL[i] || "⭐"} {i + 1}.º puesto</span><b className={i === 0 ? "lime" : ""}>+{eur0(p)}</b></div>)}</div>
        <h3 style={{ marginTop: 20 }}>📜 Cierres anteriores</h3>
        {r.closures.length === 0 ? <p className="tiny muted">Aún no se ha cerrado ninguna semana.</p> : r.closures.map((c) => <p key={c.week} className="tiny muted">Semana {c.week}: {c.winners.map((w) => `${w.position}.º ${w.alias} (${num(w.xp)} XP)`).join(" · ") || "sin participantes"}</p>)}
      </div>
    </>
  );
}
